import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpeachToText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSpeachToText"><Path fillRule="evenodd" clipRule="evenodd" d="M7.50195 3V17H5.50195V3H7.50195ZM14.502 4V9.5H12.502V4H14.502ZM11.002 6V14H9.00195V6H11.002ZM4.00195 8V12H2.00195V8H4.00195ZM12.502 11H22.502V14.5556H20.502V13H18.502V19H20.002V21H15.002V19H16.502V13H14.502V14.5556H12.502V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpeachToText;
